<template>
  <div
    :id="`${source}_super_agi_activity_analytics`"
    class="flex flex-col gap-4"
  >
    <AnalyticsFilterComponent :allowed-filters="superAGIAllowedFilters" />

    <div class="flex flex-col gap-8 mb-3">
      <div
        v-for="(component, index) in visibleComponents"
        :key="`${component.id}_component_${index}`"
        class="flex flex-col gap-3"
      >
        <span class="text-lg font-semibold">{{ component.text }}</span>
        <component
          :is="component.component"
          :source="source"
          :activity-type="component.id"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import { superAGIAllowedFilters } from "@/src/constants/analyticConstants.js";
import AnalyticsFilterComponent from "@/src/views/analytics/v2/AnalyticsFilterComponent.vue";
import SuperAGIEmailActivityAnalytics from "@/src/views/analytics/v2/superagi_activity_analytics/email/SuperAGIEmailAnalytics.vue";
import SuperAGILinkedinAnalytics from "@/src/views/analytics/v2/superagi_activity_analytics/linkedin/SuperAGILinkedinAnalytics.vue";
import SuperAGIProspectingActivityAnalytics from "@/src/views/analytics/v2/superagi_activity_analytics/prospecting/SuperAGIProspectingAnalytics.vue";
import SuperAGIMarketResearchActivityAnalytics from "@/src/views/analytics/v2/superagi_activity_analytics/market_research_agent/SuperAGIMarketResearchAnalytics.vue";

const props = defineProps({
  source: { type: String, required: true },
});

const components = ref([
  {
    id: "email_activity_analytics",
    text: "Email",
    component: SuperAGIEmailActivityAnalytics,
    show: true,
  },
  {
    id: "linkedin_activity_analytics",
    text: "LinkedIn",
    component: SuperAGILinkedinAnalytics,
    show: false,
  },
  {
    id: "prospecting_activity_analytics",
    text: "Prospecting",
    component: SuperAGIProspectingActivityAnalytics,
    show: true,
  },
  {
    id: "market_research_activity_analytics",
    text: "Market Research Agent",
    component: SuperAGIMarketResearchActivityAnalytics,
    show: true,
  },
]);

const visibleComponents = computed(() =>
  components.value.filter((component) => component.show),
);

onMounted(() => {
  if (localStorage.getItem("analytics_new_features")) {
    const linkedinComponent = components.value.find(
      (component) => component.id === "linkedin_activity_analytics",
    );
    if (linkedinComponent) {
      linkedinComponent.show = true;
    }
  }
});
</script>
